module.exports = __webpack_public_path__ + "static/media/logoIcon.43a0a56d.png";